import type { SendReminderEmailRequest } from '@vy/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../../services/api';

export function useRemindPayment(options?: UseMutationOptions<void, unknown, SendReminderEmailRequest>) {
  const api = getPrivateApi();

  return useMutation({
    mutationFn: async (reminderEmailRequest) =>
      api.sendReminderEmail({ sendReminderEmailRequestSchema: reminderEmailRequest }),
    ...options,
  });
}
